"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMRManager = void 0;
const EMRMapper_1 = require("../../mappers/EMRMapper"); // Do not shorten this import as it creates a cyclic dependency
class EMRManager {
    constructor(httpAdapter) {
        this.httpAdapter = httpAdapter;
        this._insuranceInformation = undefined;
        this._physicianInformation = undefined;
        this._diagnosisInformation = undefined;
    }
    get physicianInformation() {
        return this._physicianInformation;
    }
    get diagnosisInformation() {
        return this._diagnosisInformation;
    }
    get insuranceInformation() {
        return this._insuranceInformation;
    }
    get patientInformation() {
        return this._patientInformation;
    }
    fetchInsuranceInformation(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            this._insuranceInformation = undefined;
            if (mrn) {
                const response = yield this.httpAdapter
                    .getEMRAdapter()
                    .fetchInsuranceDetails(mrn, context);
                if (!response.isAborted) {
                    this._insuranceInformation = (0, EMRMapper_1.insuranceMapper)(response.data);
                }
            }
        });
    }
    fetchPatientInformation(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            this._patientInformation = undefined;
            if (mrn) {
                const response = yield this.httpAdapter
                    .getEMRAdapter()
                    .fetchPatientDetails(mrn, context);
                if (!response.isAborted) {
                    this._patientInformation = response.data
                        ? (0, EMRMapper_1.patientInformationMapper)(response.data)
                        : response.data;
                }
            }
        });
    }
    fetchPhysicianInformation(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            this._physicianInformation = undefined;
            if (mrn) {
                const response = yield this.httpAdapter
                    .getEMRAdapter()
                    .fetchPhysicianDetails(mrn, context);
                if (!response.isAborted) {
                    this._physicianInformation = (0, EMRMapper_1.physicianMapper)(response.data);
                }
            }
        });
    }
    fetchDiagnosisInformation(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            this._diagnosisInformation = undefined;
            if (mrn) {
                const response = yield this.httpAdapter
                    .getEMRAdapter()
                    .fetchDiagnosisDetails(mrn, context);
                if (!response.isAborted) {
                    this._diagnosisInformation = (0, EMRMapper_1.diagnosisMapper)(response.data);
                }
            }
        });
    }
    getRecentLookups() {
        return __awaiter(this, arguments, void 0, function* (limit = 10) {
            const response = yield this.httpAdapter
                .getEMRAdapter()
                .fetchRecentMRNs(limit);
            if (response.isAborted || !response.data) {
                return [];
            }
            return (0, EMRMapper_1.recentMRNsMapper)(response.data);
        });
    }
}
exports.EMRManager = EMRManager;
